<div *ngrxLet="legalStandardBalance$ as legalStandardBalance" data-test="nitrogen-cuts">
  @if (legalStandardBalance?.nitrogenCuts) {
    <div class="flex--row flex--nowrap">
      @if (legalStandardBalance.nitrogenCuts.cutsTotalInKgN > 0) {
        <div class="spacing--margin-right">
          <div class="text--label">
            {{ 'nitrogenCuts.quickviewLabel' | translate }}
          </div>
          <div class="flex--row flex--nowrap flex--align-center">
            <span class="flex__child--auto"
              >&nbsp;{{
                legalStandardBalance.nitrogenCuts.cutsTotalInKgN | agrNumber: '1.0-0'
              }}</span
            >
          </div>
        </div>
      }
    </div>
  }
</div>
